import { Container, Accordion, Row, Col } from 'react-bootstrap';

const FaqPage = () => {
    // Daftar pertanyaan dan jawaban
    const faqData = [
        {
            eventKey: "0",
            question: "Bagaimana cara saya mendaftar untuk lelang?",
            answer: "Anda dapat mendaftar dengan membuat akun di website kami dan melengkapi data diri yang diperlukan. Setelah terverifikasi, Anda dapat langsung mengikuti lelang yang sedang berlangsung."
        },
        {
            eventKey: "1",
            question: "Apa saja metode pembayaran yang diterima?",
            answer: "Kami menerima pembayaran melalui transfer bank ke rekening resmi Syailendra Auction. Detail rekening akan diberikan setelah Anda memenangkan sebuah lot."
        },
        {
            eventKey: "2",
            question: "Bagaimana cara saya mengetahui keaslian barang?",
            answer: "Setiap barang yang kami lelang telah melalui proses verifikasi dan otentikasi oleh tim ahli numismatik kami. Kami menjamin keaslian setiap item yang kami tawarkan."
        },
        {
            eventKey: "3",
            question: "Kapan saya akan menerima barang yang saya menangkan?",
            answer: "Barang akan dikirimkan ke alamat Anda setelah kami menerima konfirmasi pembayaran penuh. Proses pengiriman biasanya memakan waktu 3-5 hari kerja untuk wilayah domestik."
        },
        {
            eventKey: "4",
            question: "Apakah ada biaya tambahan selain harga palu?",
            answer: "Ya, ada biaya tambahan yang disebut 'buyer's premium' sebesar 20% dari harga palu (harga kemenangan lelang). Biaya ini akan ditambahkan ke total tagihan Anda."
        }
    ];

    return (
        <div className="py-5" style={{ backgroundColor: '#f0efe9' }}>
            <Container>
                <div className="text-center mb-5">
                    <h1 className="display-4" style={{ fontFamily: 'Cinzel, serif' }}>Frequently Asked Questions (FAQ)</h1>
                    <p className="lead" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        Temukan jawaban untuk pertanyaan yang paling sering diajukan di sini.
                    </p>
                </div>

                <Row className="justify-content-center">
                    <Col md={10} lg={8}>
                        <Accordion defaultActiveKey="0" flush>
                            {faqData.map(item => (
                                <Accordion.Item eventKey={item.eventKey} key={item.eventKey} className="mb-2">
                                    <Accordion.Header>{item.question}</Accordion.Header>
                                    <Accordion.Body>
                                        {item.answer}
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                        </Accordion>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default FaqPage;
